// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"PromoBlock_imageContainer__Y4Xkv"};